import { Controller } from '@hotwired/stimulus';
import flatpickr from 'flatpickr';
import { Spanish } from 'flatpickr/dist/l10n/es';
import 'flatpickr/dist/flatpickr.min.css';
import type { Instance } from 'flatpickr/dist/types/instance';

export default class extends Controller {

    static values = {
        dateFormat: { type: String, default: 'Y-m-d' },
        altFormat:  { type: String, default: 'd/m/Y' },
        allowInput: { type: Boolean, default: true },
    };

    declare readonly dateFormatValue: string;
    declare readonly altFormatValue: string;
    declare readonly allowInputValue: boolean;

    private fp!: Instance;

    connect(): void {
        this.fp = flatpickr(this.element as HTMLInputElement, {
            locale:        Spanish,
            dateFormat:    this.dateFormatValue,
            altInput:      true,
            altFormat:     this.altFormatValue,
            allowInput:    this.allowInputValue,
            disableMobile: true,
            onChange:      (selectedDates) => {
                this.syncInput(selectedDates[0], true);
                this.clearError();
            },
            onValueUpdate: (selectedDates) => {
                this.syncInput(selectedDates[0], true);
                this.clearError();
            },
        }) as Instance;
    }

    disconnect(): void {
        this.fp?.destroy();
    }

    private syncInput(date?: Date, allowClear = false): void {
        if (!date) {
            if (allowClear && !this.fp.altInput?.value) {
                (this.element as HTMLInputElement).value = '';
            }
            return;
        }

        (this.element as HTMLInputElement).value = this.fp.formatDate(date, this.dateFormatValue);
    }

    private clearError(): void {
        const input = this.element as HTMLInputElement;
        input.classList.remove('is-invalid');
        this.fp.altInput?.classList.remove('is-invalid');

        const wrapper = input.closest('.mb-3, .col-md-6, .form-group') ?? input.parentElement;
        wrapper?.querySelectorAll('.invalid-feedback, .form-error-message').forEach((error) => {
            error.remove();
        });
    }
}
